// externals
import type { Reducer } from 'redux';

// libraries
import type { TradeInIntelligenceState } from '@makemydeal/dr-dash-types';
import { actions as offerReduxActionTypes } from '@makemydeal/dr-offer-redux';

// consts/enums
import {
    TRADE_IN_INTELLIGENCE_EVENT_RECEIVED,
    TRADE_IN_INTELLIGENCE_REQUESTED,
    TRADE_IN_INTELLIGENCE_REQUEST_ACCEPTED,
    TRADE_IN_INTELLIGENCE_SETTLED_EMPTY
} from '../actionTypes/tradeInIntelligenceActionTypes';

export type TradeInIntelligenceReducer = Reducer<TradeInIntelligenceState>;

export const initialState: TradeInIntelligenceState = {
    status: 'idle',
    records: [],
    requestedAtMs: null,
    correlationId: null
};

export const reducer: TradeInIntelligenceReducer = (state: TradeInIntelligenceState = initialState, action: any) => {
    switch (action.type) {
        case TRADE_IN_INTELLIGENCE_REQUESTED: {
            if (state.status !== 'idle') {
                return state;
            }
            return { ...state, status: 'pending' as const, records: [], requestedAtMs: action.payload.requestedAtMs };
        }

        case TRADE_IN_INTELLIGENCE_REQUEST_ACCEPTED: {
            if (state.status !== 'pending') {
                return state;
            }
            return { ...state, correlationId: action.payload.correlationId };
        }

        case TRADE_IN_INTELLIGENCE_SETTLED_EMPTY: {
            if (state.status !== 'pending') {
                return state;
            }
            return { ...state, status: 'settled' as const, records: [] };
        }

        case TRADE_IN_INTELLIGENCE_EVENT_RECEIVED: {
            if (state.status !== 'pending') {
                return state;
            }
            const { state: pushState, records } = action.payload ?? {};
            const received = pushState === 'ready' && Array.isArray(records) ? records : [];
            return { ...state, status: 'settled' as const, records: received };
        }

        case offerReduxActionTypes.SWAPPED_GLOBAL_CUSTOMER_IDS: {
            return initialState;
        }

        default: {
            return state;
        }
    }
};
